// src\themes\tolica\components\VideoBanner.tsx
'use client';

import Link from 'next/link';
import Image from 'next/image';
import { ArrowDown } from 'lucide-react';

const isVideoUrl = (url?: string) => {
    if (!url) return false;
    return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url);
};

interface VideoBannerProps {
    data?: {
        title?: string | null;
        buttonContent?: string | null;
        link?: string | null;
        image_info?: { url: string; description?: string } | null;
    };
}

export default function VideoBanner({ data }: VideoBannerProps) {
    if (!data || !data.image_info?.url) return null;

    const isVideo = isVideoUrl(data.image_info.url);

    return (
        <div className="col-span-12 relative w-full h-[90vh] overflow-hidden bg-black">
            {isVideo ? (
                <video
                    src={data.image_info.url}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover"
                />
            ) : (
                <Image
                    src={data.image_info.url}
                    alt={data.image_info.description || data.title || ''}
                    fill
                    priority
                    className="object-cover"
                />
            )}

            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />

            {/* متن راست‌چین، کمی پایین‌تر از وسط بنر */}
            <div className="absolute inset-x-0 bottom-8 md:bottom-12 flex flex-col items-start justify-center gap-3 text-right px-4 sm:px-8 lg:px-16 text-primary-0">
                {data.title && (
                    <h2 dir="ltr" className="text-3xl md:text-6xl font-light tracking-wide">
                        {data.title}
                    </h2>
                )}
                {data.buttonContent && (
                    data.link ? (
                        <Link
                            href={data.link}
                            className="text-sm md:text-base underline underline-offset-4 opacity-90 hover:opacity-100 transition-opacity"
                        >
                            {data.buttonContent}
                        </Link>
                    ) : (
                        <span className="text-sm md:text-base underline underline-offset-4 opacity-90">
                            {data.buttonContent}
                        </span>
                    )
                )}
            </div>


        </div>
    );
}